// Copyright (c) 2017 Deere & Company

import AuditResultsCellRenderer from '../../shared/report-cell-renderers/audit-results-cell-renderer';
import ClaimNumberCellRenderer from '../../shared/report-cell-renderers/claim-number-cell-renderer';
import CreditMemoCellRenderer from '../../shared/report-cell-renderers/credit-memo-cell-renderer';
import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import FileCellRenderer from '../../shared/report-cell-renderers/file-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getAuditSummaryColumnDefinitions(onAuditResultClick) {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'auditNumber',
            field: 'auditNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('AUDIT_NUMBER'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'territory',
            field: 'territory',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('TERRITORY'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'account',
            field: 'account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin ',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: ClaimNumberCellRenderer,
            colId: 'claimNumber',
            field: 'claimNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM_NUMBER'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'workRepairOrder',
            field: 'workRepairOrder',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WORK_ORDER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reference2',
            field: 'reference2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REFERENCE_2'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'claimType',
            field: 'claimType',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM_TYPE'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: CreditMemoCellRenderer,
            colId: 'creditMemo',
            field: 'creditMemo',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CREDIT_MEMO'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'city',
            field: 'city',
            headerClass: classNames.headerClassName,
            headerName: translate('CITY'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'state',
            field: 'state',
            headerClass: classNames.headerClassName,
            headerName: translate('STATE'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'leadAccount',
            field: 'leadAccount',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LEAD_ACCOUNT'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'auditTypeDescription',
            field: 'auditTypeDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('AUDIT_TYPE'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'creditMemoSelected',
            field: 'creditMemoSelected',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CREDIT_MEMO_SELECTED'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'debitRequiredDescription',
            field: 'debitRequiredDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('DEBIT_REQUIRED'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'debitAmount',
            field: 'debitAmount',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEBIT_AMOUNT'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'reasonForDebit',
            field: 'reasonForDebit',
            headerClass: classNames.headerClassName,
            headerName: translate('REASON_FOR_DEBIT'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'debitRequestStatus',
            field: 'debitRequestStatus',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEBIT_REQUIRED_STATUS'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'actualAuditDate',
            field: 'actualAuditDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('ACTUAL_AUDIT_DATE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'plannedBy',
            field: 'plannedBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PLANNED_BY'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'completedBy',
            field: 'completedBy',
            headerClass: classNames.headerClassName,
            headerName: translate('COMPLETED_BY'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: AuditResultsCellRenderer,
            cellRendererParams: {
                onClick: onAuditResultClick
            },
            colId: 'auditResult',
            headerClass: classNames.headerClassName,
            headerName: translate('AUDIT_RESULTS'),
            valueGetter: params => params.data.auditResults.length ? params.data.auditResults[0].description : null,
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: FileCellRenderer,
            colId: 'file',
            field: 'file',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FILE_NAME'),
            width: 150
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/audit-summary/report-services/column-definitions.js